import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { titleUrl } from "@/lib/api";

export function MovieCard({ t, size = "md" }) {
  const w = size === "sm" ? "w-[120px] sm:w-[140px]" : size === "fluid" ? "w-full" : "w-[140px] sm:w-[170px] lg:w-[185px]";
  return (
    <Link to={titleUrl(t)} data-testid={`movie-card-${t.slug}`} className={`group shrink-0 ${w} snap-start`}>
      <div className="relative aspect-[2/3] overflow-hidden rounded-xl border border-white/5 bg-[#181824]">
        {t.poster ? (
          <img src={t.poster.replace("/w500/", "/w342/")} alt={`${t.title} (${t.year}) poster`} loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="flex h-full items-center justify-center p-3 text-center font-display text-2xl text-amber-400">{t.title}</div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        {t.rating_count > 0 && (
          <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-black/70 px-2 py-0.5 text-[11px] font-semibold text-purple-300 backdrop-blur">
            <Star className="h-3 w-3 fill-purple-400 text-purple-400" /> {t.rating_avg?.toFixed(1)}
          </span>
        )}
        {t.type !== "movie" && (
          <span className="absolute right-2 top-2 rounded-full bg-amber-400 px-2 py-0.5 text-[10px] font-bold uppercase text-black">{t.type === "tv" ? "Series" : "Anime"}</span>
        )}
      </div>
      <p className="mt-2 line-clamp-1 text-sm font-semibold text-slate-100 group-hover:text-amber-400 transition-colors">{t.title}</p>
      <p className="text-xs text-slate-500">{t.year} {t.genres?.[0] ? `· ${t.genres[0]}` : ""}</p>
    </Link>
  );
}
